import {
  REMOVE_FAV,
  REMOVE_FAV_SUCCESS,
  REMOVE_FAV_CLEAN,
  REMOVE_FAV_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  fav: undefined,
}

const FavRemove = (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_FAV:
      state = {
        ...state,
        loading: true,
      }
      break
    case REMOVE_FAV_SUCCESS:
      state = {
        ...state,
        fav: action.payload.fav,
        loading: false,
        done: true,
      }
      break
    case REMOVE_FAV_CLEAN:
      state = initialState
      break
    case REMOVE_FAV_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default FavRemove
